// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._4BF5LQUgx{position:relative}.XvGxOyy6x{width:.1px;height:.1px;opacity:0;overflow:hidden;position:absolute;z-index:-1}", "",{"version":3,"sources":["webpack://./client/shared/drop-zone/drop-zone.scss"],"names":[],"mappings":"AAEA,YACE,iBAAA,CAGF,WACE,UAAA,CACA,WAAA,CACA,SAAA,CACA,eAAA,CACA,iBAAA,CACA,UAAA","sourcesContent":["@import \"../styles/variables.scss\";\n\n.drop-zone {\n  position: relative;\n}\n\n.input {\n  width: 0.1px;\n  height: 0.1px;\n  opacity: 0;\n  overflow: hidden;\n  position: absolute;\n  z-index: -1;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tabletScreen": "768px",
	"smallScreen": "1100px",
	"mediumScreen": "1300px",
	"largeScreen": "1500px",
	"azure": "#006fc8",
	"cyan": "#1faece",
	"primaryText": "var(--primary-text)",
	"secondaryText": "var(--secondary-text)",
	"chartGridColor": "var(--ui-divider)",
	"gray10": "#dedede",
	"msDarkBlue": "#002050",
	"amberLight2": "#f7e28b",
	"violetLight2": "#cec0ec",
	"tealLight3": "#cfece8",
	"bannerBlue": "var(--banner-blue)",
	"spaceXXS": "4px",
	"spaceXS": "8px",
	"spaceS": "16px",
	"spaceM": "20px",
	"spaceXM": "24px",
	"spaceL": "32px",
	"spaceXL": "40px",
	"spaceXXL": "60px",
	"panelSlideDuration": "200ms",
	"panelFadeDuration": "100ms",
	"ccBannerHeight": "46px",
	"drop-zone": "_4BF5LQUgx",
	"dropZone": "_4BF5LQUgx",
	"input": "XvGxOyy6x"
};
export default ___CSS_LOADER_EXPORT___;
